<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>Add CTC</h3>
        <h4>2/4</h4>
      </div>
      <div class="row d-flex justify-content-center">
        <form class="col-xl-6" [formGroup]="form">
          <div class="my-4">
            <label for="basis" class="form-label">Basis</label>
            <select class="form-select" id="currency" formControlName="basis">
              <option selected value="">Select Basis</option>
              <option *ngFor="let val of CTCBasisValues" [ngValue]="val">
                {{ val | capitalize }}
              </option>
            </select>
          </div>
          <div class="my-4">
            <label for="currency" class="form-label">Currency</label>
            <select class="form-select" id="currency" formControlName="currency">
              <option selected value="">Select Currency</option>
              <option *ngFor="let country of countries$ | async" [ngValue]="country.currency">
                {{ country.currency_name }}
              </option>
            </select>
          </div>
          <div class="my-4">
            <label for="ctc" class="form-label">CTC <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="ctc"
              autocomplete="off"
              appIndianNumberInputFormat
              appTrimInput
            />
            <div *ngIf="form.get('ctc')?.errors?.['required']">
              <span class="text-danger">
                {{ getErrorMessage('ctc') }}
              </span>
            </div>
          </div>
          <input type="hidden" formControlName="effectiveFrom" />
          <input type="hidden" formControlName="payoutFrom" />
        </form>
      </div>
    </div>
  </div>
</div>
